import React from "react";
import { useTailwindCdn } from "./useTailwindCdn";

export function withProductionStyles(Component) {
  return function Wrapped(props) {
    useTailwindCdn({ corePlugins: { preflight: false } });
    return <Component {...props} />;
  };
}
